import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ProductType } from '@apps/api-interfaces';
import { filter, takeUntil } from 'rxjs/operators';
import { ThemeService, AgentService, SchemaService, WebMcpService } from './_shared/services';
import { ORGANIZATION_SCHEMA, WEBSITE_SCHEMA } from './_shared/services/schemas';
import { Router, NavigationEnd } from '@angular/router';
import { Destroyer, setTheme, setCookie, getCookie } from '@apps/tools';
import { MetadataService, ScrollService, DetectDeviceService, TrafficService } from '@apps/ui';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'sc-root',
  template: `
    <sc-alert-messages *ngIf="showAlerts"></sc-alert-messages>
    <router-outlet></router-outlet>
  `
})
export class AppComponent extends Destroyer implements OnInit {

  showAlerts: boolean;

  @HostListener('window:resize') onResize() {
    this.setBodyParams();
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private theme: ThemeService,
    private router: Router,
    private agent: AgentService,
    private meta: MetadataService,
    private traffic: TrafficService,
    private scroll: ScrollService,
    private browser: DetectDeviceService,
    private schema: SchemaService,
    private webMcp: WebMcpService
  ) {
    super();

    // JSON-LD wspolne dla calej porownywarki (Organization ma @id wspolny
    // z grafem zatrzymajlicznik.pl).
    this.schema.setGlobal('organization', ORGANIZATION_SCHEMA);
    this.schema.setGlobal('website', WEBSITE_SCHEMA);

    // WebMCP: narzedzia flow porownywarki dla agentow przegladarkowych
    // (no-op gdy przegladarka nie wspiera navigator.modelContext).
    this.webMcp.init();

    this.setAgentCookie();
    this.scroll.initRouterScroll();
    this.meta.initRouterUpdateMeta();
    this.traffic.initRouterEvents();
    this.agent.log('init');

    this.theme.product$
      .pipe(takeUntil(this.destroy$))
      .subscribe((type: ProductType) => {
        setTheme(type);
      });
  }

  ngOnInit() {
    this.showAlerts = isPlatformBrowser(this.platformId);
    this.setBodyParams();
    this.browser.setBodyData();
  }

  private setBodyParams(): void {
    document.body.style.setProperty('--vh', `${window.innerHeight}px`);
  }

  private setAgentCookie() {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(e => !getCookie('cid') && e instanceof NavigationEnd)
      )
      .subscribe((e: NavigationEnd) => {
        if (e.urlAfterRedirects === '/prad' && e.url.indexOf('cid=') > -1) {
          const params = new URLSearchParams(e.url.replace('/?',''));
          const cid = params.get('cid');
          setCookie('cid', cid, 90);
        }
      });

  }
}
